module.exports = __webpack_public_path__ + "img/empty_3.36fd4203.png";